import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const ProgressIndicator = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, label: 'Project', icon: 'FileText' },
    { number: 2, label: 'Woning', icon: 'Home' },
    { number: 3, label: 'Planning', icon: 'Calendar' },
    { number: 4, label: 'Contact', icon: 'User' }
  ];

  return (
    <div className="bg-card border-b border-border py-6 shadow-[0_4px_14px_0_rgba(0,0,0,0.08)]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {steps?.map((step, index) => (
            <React.Fragment key={step?.number}>
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all shadow-[0_4px_14px_0_rgba(0,0,0,0.1)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.15)] hover:-translate-y-1 transform duration-300",
                    currentStep > step?.number
                      ? "bg-primary border-primary text-primary-foreground shadow-[0_4px_14px_0_rgba(59,130,246,0.3)]"
                      : currentStep === step?.number
                      ? "bg-primary/10 border-primary text-primary shadow-[0_4px_14px_0_rgba(59,130,246,0.2)]" :"bg-card border-border text-muted-foreground"
                  )}
                >
                  {currentStep > step?.number ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <Icon name={step?.icon} size={20} />
                  )}
                </div>
                <span
                  className={cn(
                    "text-xs mt-2 font-medium",
                    currentStep >= step?.number ? "text-foreground" : "text-muted-foreground"
                  )}
                >
                  {step?.label}
                </span>
              </div>

              {/* Connector Line */}
              {index < steps?.length - 1 && (
                <div className="flex-1 h-0.5 mx-2 sm:mx-4">
                  <div
                    className={cn(
                      "h-full transition-all",
                      currentStep > step?.number ? "bg-primary" : "bg-border"
                    )}
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;